import React from "react";

const DpzLogo = () => (
  <svg
    className="dpz-logo"
    xmlns="http://www.w3.org/2000/svg"
    width="69.881"
    height="69.885"
    viewBox="0 0 69.881 69.885"
  >
    <path
      fill="#FFF"
      d="M68.64 20.227L49.66 1.242C48.854.442 47.79 0 46.66 0c-1.136 0-2.2.44-3 1.242L27.737 17.164 1.24 43.66c-1.653 1.654-1.653 4.347 0 6l18.984 18.982c.8.8 1.866 1.242 3 1.242 1.133 0 2.198-.44 3-1.242l23.75-23.75L68.64 26.224c1.655-1.652 1.655-4.344 0-5.997"
    />
    <path
      fill="#E21D38"
      d="M67.298 21.576L48.316 2.593c-.917-.916-2.4-.916-3.315 0L24.476 23.118l22.297 22.297L67.298 24.89c.915-.914.915-2.398 0-3.314m-16.695 5.488c-1.073 1.073-2.484 1.61-3.89 1.61-1.403 0-2.81-.537-3.888-1.61-1.07-1.074-1.612-2.484-1.612-3.89 0-1.406.542-2.817 1.612-3.887 1.077-1.072 2.482-1.612 3.89-1.612 1.403 0 2.814.535 3.888 1.613 1.07 1.07 1.613 2.48 1.613 3.887 0 1.404-.542 2.816-1.613 3.89"
    />
    <path
      fill="#006592"
      d="M2.583 45.003c-.916.915-.916 2.397 0 3.314L21.566 67.3c.457.46 1.057.688 1.657.688.6 0 1.2-.23 1.657-.688l20.517-20.515-22.3-22.297L2.584 45.003zm16.44 5.468c-1.077 1.068-2.486 1.605-3.89 1.605-1.41 0-2.816-.535-3.89-1.604-1.075-1.07-1.608-2.48-1.608-3.886 0-1.408.535-2.815 1.608-3.893 1.074-1.07 2.48-1.605 3.89-1.607 1.404.002 2.815.537 3.89 1.608 1.072 1.078 1.607 2.485 1.605 3.892 0 1.406-.533 2.818-1.606 3.89m8.36-7.556c1.074-1.075 2.483-1.612 3.888-1.612 1.407 0 2.815.537 3.888 1.612 1.077 1.073 1.615 2.478 1.615 3.89 0 1.403-.538 2.812-1.615 3.882-1.072 1.07-2.48 1.61-3.888 1.612-1.406 0-2.814-.54-3.887-1.612-1.074-1.07-1.612-2.48-1.612-3.883 0-1.407.54-2.816 1.612-3.89"
    />
    <path
      fill="#FFF"
      d="M31.477 65.128c.766 0 1.42.596 1.42 1.403 0 .814-.654 1.41-1.42 1.41-.772 0-1.427-.596-1.427-1.41 0-.806.655-1.402 1.427-1.402m0 .23c-.652 0-1.154.502-1.154 1.173 0 .687.502 1.183 1.154 1.183.646 0 1.148-.496 1.148-1.182 0-.67-.502-1.173-1.148-1.173m-.298 1.988h-.25v-1.62h.62c.385 0 .576.144.576.462 0 .292-.182.416-.425.446l.465.712h-.276l-.432-.704h-.28v.705zm0-.907h.294c.302 0 .402-.088.402-.267 0-.154-.078-.242-.36-.242h-.337v.51z"
    />
  </svg>
);

export default DpzLogo;
